import { QueryStatus } from '@reduxjs/toolkit/query';
import React from 'react';

import { useGetTransactionStatusQuery } from '@/api/v1';
import { TransactionNotification } from '@/types/transaction';

export const useTransactionNotification = (
  transactionId: string | null,
): readonly TransactionNotification[] => {
  const [notifications, setNotifications] = React.useState<readonly TransactionNotification[]>([]);

  const { data, status: pollingStatus } = useGetTransactionStatusQuery(transactionId, {
    skip: transactionId === null,
    skipPollingIfUnfocused: true,
    pollingInterval: 2500,
  });

  React.useEffect((): void => {
    if (pollingStatus === QueryStatus.pending) {
      return;
    } else if (data) {
      setNotifications(data);
    }
  }, [data, pollingStatus]);

  return notifications;
};
